import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Common Info ")

export function render(_ctx, _cache) {
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          disabled: _ctx.loading,
          icon: "pi pi-refresh",
          class: "p-button-rounded p-button-outlined",
          onClick: _ctx.refresh
        }, null, 8, ["disabled", "onClick"])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, " Load Avd 1: " + _toDisplayString(_ctx.round(_ctx.load.loadavg1)) + " Load Avd 5: " + _toDisplayString(_ctx.round(_ctx.load.loadavg5)) + " Load Avd 15: " + _toDisplayString(_ctx.round(_ctx.load.loadavg15)), 1),
      _createElementVNode("div", null, " Up Time: " + _toDisplayString(_ctx.up), 1)
    ]),
    _: 1
  }))
}